import { render, staticRenderFns } from "./CategoryEquipmentListTable.vue?vue&type=template&id=97fa2bc6"
import script from "./CategoryEquipmentListTable.vue?vue&type=script&lang=js"
export * from "./CategoryEquipmentListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports